import angular from 'angular';
import 'angular-ui-bootstrap/src/buttons/buttons';

import template from './template.jade';
import './styles.styl';

export default angular
	.module('ui.cian.switcher', ['ui.bootstrap.buttons'])
	.constant('uibButtonConfig', {
		activeClass: 'cui-switcher__part_state_active',
		toggleEvent: 'click touchstart'
	})
	.directive('cianUiSwitcher', () => ({
		scope: {},
		bindToController: {
			items: '=',
			valueKey: '@',
			textKey: '@',
			uncheckable: '@',
			cuiInvalid: '=',
			cuiRequired: '=',
			modelName: "@markModelName",
			defaultValue: '=',
			trackBy: '&?'
		},
		require: ['cianUiSwitcher', 'ngModel'],
		link(scope, elem, attrs, [cianUiSwitcher, ngModelCtrl]) {
			scope.onChange = () => {
				ngModelCtrl.$setViewValue(scope.switcher.model);
				ngModelCtrl.$render();
				ngModelCtrl.$setTouched();
			};

			ngModelCtrl.$render = () => {
				scope.switcher.model = ngModelCtrl.$modelValue;
			};

			ngModelCtrl.$parsers.push((viewValue) => {
				scope.switcher.model = viewValue;
				return viewValue;
			});

			scope.$watch(() => cianUiSwitcher.items, items => {
				if (angular.isUndefined(items)) return;
				if (!items.some(item => item[cianUiSwitcher.valueKey] === ngModelCtrl.$modelValue)) {
					ngModelCtrl.$setViewValue(cianUiSwitcher.defaultValue);
				}
			});
		},
		controller() {
			this.valueKey = this.valueKey || 'value';
			this.textKey = this.textKey || 'text';

			this.trackByFunc = (item, index, $id) => {
				if (this.trackBy) {
					return this.trackBy({$item: item, $index: index, $id: $id});
				}
				return item[this.valueKey];
			};
		},
		controllerAs: 'switcher',
		replace: true,
		template
	}))
	.name;
